import { Link } from 'react-router';
import { AdminPageHeader } from '../../../components/AdminPageHeader';
import { ADMIN_DELIVERY_ZONES_PATH, ADMIN_DELIVERY_MAP_GENERATIONS_PATH } from '../adminRoutes';
import { LiveDeliveryGeometryMap } from './LiveDeliveryGeometryMap';
import { useDeliveryMapGeometry } from './useDeliveryMapGeometry';
import { DeliveryMapZone } from './deliveryMapTypes';
import './deliveryLiveMap.css';

const NO_ZONES: DeliveryMapZone[] = [];

export function DeliveryZoneLiveMapPage() {
  const { query, onBoundsChange, changePage, refresh, hasViewport } = useDeliveryMapGeometry();
  const page = query.data;
  const zones = query.isError ? NO_ZONES : page?.items ?? NO_ZONES;
  const isPending = !hasViewport || query.isFetching;
  const lastRefresh = query.dataUpdatedAt === 0 ? null : new Date(query.dataUpdatedAt).toLocaleString('ru-RU');
  return (
    <section className="admin-page delivery-live-map">
      <AdminPageHeader title="Текущие границы зон" eyebrow="Логистика" description="Границы из текущего каталога, без ожидания публикации карты. Только просмотр." actions={<>
        <Link className="workspace-secondary-button" to={ADMIN_DELIVERY_ZONES_PATH}>Реестр и опубликованная карта</Link>
        <button className="workspace-secondary-button" type="button" disabled={isPending} onClick={refresh}>Обновить</button>
        <Link className="workspace-secondary-button" to={ADMIN_DELIVERY_MAP_GENERATIONS_PATH}>Генерации карты</Link>
      </>} />
      <p>Перемещайте карту для загрузки зон в видимой области. На карте показана только выбранная страница, до 50 зон.</p>
      <div aria-live="polite" aria-busy={isPending}>
        {isPending && <p role="status">Загрузка текущих границ…</p>}
        {query.isError && <p className="admin-message admin-message_error" role="alert">{query.error.message}</p>}
        {lastRefresh !== null && <p>Последняя загрузка: {lastRefresh}{query.isError ? ' · Обновить данные не удалось.' : ''}</p>}
        {!isPending && !query.isError && page?.meta.total === 0 && <p>Зон в этой области нет. Переместите карту или обновите данные.</p>}
      </div>
      <LiveDeliveryGeometryMap zones={zones} onBoundsChange={onBoundsChange} />
      {page !== undefined && !query.isError && <nav className="delivery-live-map__pagination" aria-label="Страницы зон в области">
        <p>{page.meta.page_count === 0 ? 'Страниц: 0' : `Страница ${page.meta.page} из ${page.meta.page_count}`} · Всего в области: {page.meta.total} · На карте: {zones.length}</p>
        <div className="delivery-live-map__actions">
          <button className="workspace-secondary-button" type="button" disabled={isPending || page.meta.page <= 1} onClick={() => changePage(page.meta.page - 1)}>Назад</button>
          <button className="workspace-secondary-button" type="button" disabled={isPending || page.meta.page >= page.meta.page_count} onClick={() => changePage(page.meta.page + 1)}>Далее</button>
        </div>
      </nav>}
      <ul className="delivery-live-map__identities" aria-label="Зоны выбранной страницы">
        {zones.map((zone) => <li key={zone.zone_id}><strong>{zone.zone_name}</strong> · ID {zone.zone_id} · Код: <span>{zone.zone_code ?? '—'}</span> · ID карты: {zone.zone_map_id ?? '—'}{zone.zone_region_name ? ` · ${zone.zone_region_name}` : ''}</li>)}
      </ul>
    </section>
  );
}
